module.exports = __webpack_public_path__ + "img/logo-pinterest.474ca63e.svg";